import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

import type { HolidayEnquiryRequest } from '@/src/types/holidays'

// Relative URL: `/node/*` is proxied to ct-node by the Next rewrites, like the other node APIs.
export const holidayEnquiryApi = createApi({
    reducerPath: 'holidayEnquiryApi',
    baseQuery: fetchBaseQuery({
        prepareHeaders: headers => {
            headers.set('Accept', 'application/json')
            headers.set('Content-Type', 'application/json')
            headers.set('X-CT-SOURCETYPE', 'web')
            return headers
        }
    }),
    endpoints: builder => ({
        submitHolidayEnquiry: builder.mutation<{ success: true }, HolidayEnquiryRequest>({
            query: body => ({ url: '/node/flight/holidays/enquiry', method: 'POST', body })
        })
    })
})

export const { useSubmitHolidayEnquiryMutation } = holidayEnquiryApi
export default holidayEnquiryApi
